import { useQuery } from "@tanstack/react-query";
import { DocumentKeys } from "web_myplann/Api/Document/DocumentKeys";
import {
	type DocumentListResponseDTO,
	DocumentLocalTypeEnum,
	getDocumentV2,
} from "web_myplann/Infrastructure/Api/Api";
import { processResponse } from "web_myplann/Infrastructure/Api/ApiUtils";

export const usePinnableDocumentsQuery = (enabled: boolean) => {
	return useQuery({
		queryKey: DocumentKeys.pinnable,
		enabled,
		queryFn: processResponse(() =>
			getDocumentV2(undefined, true, DocumentLocalTypeEnum.Local, false),
		),
		select: (data: DocumentListResponseDTO) => data.documents,
	});
};
